import { Link } from 'react-router-dom';
import { ArrowLeft, Info, LogIn, UserPlus } from 'lucide-react';

/**
 * Legacy magic-link page (Feb 2026).
 * The magic-link system has been replaced by user accounts. This page is now a
 * friendly redirect explaining the change to anyone clicking an old email link.
 */
export default function BallTrapCampagneManage() {
  return (
    <div className="min-h-screen bg-[#0D0D0D] text-white font-['Manrope'] flex items-center justify-center px-4 py-12">
      <div className="fixed inset-0 -z-10 opacity-40 pointer-events-none"
        style={{ background: 'radial-gradient(circle at 20% 0%, rgba(255,193,7,0.12), transparent 50%)' }} />
      <div className="w-full max-w-md">
        <Link to="/ball-trap-campagne" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors mb-6">
          <ArrowLeft className="w-4 h-4" /> Retour à la carte
        </Link>
        <div className="rounded-2xl bg-gradient-to-br from-[#141414] to-[#0B0B0B] border border-[#FFC107]/30 p-8 text-center">
          <div className="inline-flex w-14 h-14 rounded-full bg-[#FFC107]/15 text-[#FFC107] items-center justify-center mb-4">
            <Info className="w-7 h-7" />
          </div>
          <h1 className="text-2xl font-black mb-2">Lien de gestion remplacé</h1>
          <p className="text-sm text-[#C8C8C8] leading-relaxed mb-6">
            Le système de liens par email a été remplacé par les <strong>comptes ClayPulse</strong>.
            Connectez-vous (ou créez votre compte gratuit avec le même email que celui utilisé lors de la déclaration)
            pour retrouver et gérer tous vos évènements.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/login" data-testid="legacy-go-login"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-[#FFC107] to-[#FF9800] text-black text-sm font-bold">
              <LogIn className="w-4 h-4" /> Me connecter
            </Link>
            <Link to="/register" data-testid="legacy-go-register"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full border border-white/10 hover:border-white/30 text-sm font-bold transition-colors">
              <UserPlus className="w-4 h-4" /> Créer un compte
            </Link>
          </div>
          <p className="mt-5 text-[11px] text-[#888]">
            🎁 7 jours Pro offerts à la création du compte sur l'application ClayPulse.
          </p>
        </div>
      </div>
    </div>
  );
}
